import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

/** Floating "Back to top" button. Appears after the user scrolls past 400px.
 * Positioned bottom-right, above the WaterfallDetail floating action pill so
 * it never overlaps Save / Get directions / Share.
 */
export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      data-testid="back-to-top"
      aria-label="Back to top"
      title="Back to top"
      className="fixed right-4 md:right-6 bottom-24 md:bottom-28 z-40 w-11 h-11 rounded-full bg-white text-stone-900 shadow-lg border border-stone-200 hover:bg-stone-50 hover:shadow-xl transition-all flex items-center justify-center"
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
}
